/**
 * W67 Phase 8 Variante B (2026-05-25) — Demo-Banner.
 *
 * Floating-Banner oben in der Demo-Variante: "Du siehst eine Live-Vorschau
 * der echten App. Aenderungen sind deaktiviert." + CTA-Button "Registrieren".
 */

import { Eye, X } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';

interface Props {
  /** Optional: zusaetzliche Klassennamen fuer das Container-Element. */
  className?: string;
}

export function DemoBanner({ className }: Props) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div
      className={cn(
        'sticky top-0 z-20 flex items-center gap-2 border-b border-purple-800/60 bg-gradient-to-r from-purple-950/70 via-indigo-950/60 to-purple-950/70 px-4 py-2 text-[11px] text-purple-100',
        className
      )}
    >
      <Eye className="size-3.5 shrink-0 text-purple-300" />
      <span className="flex-1 leading-snug">
        <span className="font-semibold">Live-Vorschau</span> · Das ist die echte
        SwingTrader-App im <span className="font-semibold">Read-Only-Modus</span>{' '}
        — Trades, Pläne und Einstellungen können hier nicht geändert werden.
      </span>
      <a
        href="/login"
        className="rounded border border-purple-600/70 bg-purple-800/40 px-2 py-0.5 text-[10px] font-medium text-purple-100 hover:bg-purple-700/50 hidden sm:inline-block"
      >
        Registrieren
      </a>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="rounded p-0.5 text-purple-300 hover:bg-purple-800/40 focus-ring"
        aria-label="Banner ausblenden"
      >
        <X className="size-3.5" />
      </button>
    </div>
  );
}
